"use client";

// ChatReplies: one to three things you might say next, right above the
// composer. You speak from the right, so they sit on the right in your words'
// tint (law_netti_chat). Each holds a few words (law_chip_holds_a_word); a tap
// sends it as your own message, marked so netti can learn which ones you reach
// for. They step back while you type, and never show while netti is working.
// Shared by the dashboard rail and the desk rail. The words came from your
// memory, so session replay never records them (.ph-no-capture).

import * as React from "react";
import "./netti-rows.css";

type Props = {
  replies: string[];
  onPick: (text: string) => void;
  /** a draft is being written: the replies step back, still there */
  quiet?: boolean;
  tabIndex?: number;
};

export default function ChatReplies({ replies, onPick, quiet = false, tabIndex }: Props): React.JSX.Element | null {
  if (!replies.length) return null;
  return (
    <div className="nchat-replies ph-no-capture" role="group" aria-label="replies you might send" data-quiet={quiet ? "" : undefined}>
      {replies.map((r, i) => (
        <button
          key={r}
          type="button"
          className="chip nchat-reply"
          tabIndex={tabIndex}
          style={{ ["--i" as string]: i } as React.CSSProperties}
          onClick={() => onPick(r)}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
